import xs from "xstream"
import {div, br, label, input, button} from "@cycle/dom"
import {intersperse, isEmpty, prop} from 'ramda'

import {LoginForm} from "../../../interface"
import {RESERVATION_DONE_MSG} from "../../../constant"

const parseMemo = memo => intersperse(br(), memo.split(/\r*\n/))

export const view = (form$, msg$, check$) => {
	return xs.combine(form$, msg$, check$)
		.map(([{password, newPassword, checkPassword}, msg, check]:[any, string, any]) => {
			const disabled = (!isEmpty(password) && !isEmpty(newPassword) && !isEmpty(checkPassword) && isEmpty(check)) ? "" : ".disabled"
			return div(".d-grid.gap-2", [
					div(".form-group", [
						div(".desc", [
							"◆生殖医療従事者講習会の予約サイトのパスワードも同時に変更されます。",
						])
					]),
					div(".col-md-6",[
						label(".form-label",{attrs: {for:'password'}},["現在のパスワード"]),
            input("#password.form-control", {attrs: {type:"text", placeholder:"現在のパスワード", name:'password'}, props: {value: password}})
					]),
					(prop("password", check))
						? div(".msg.mt-1",["※",prop("password",check)])
						: null
					,
					div(".col-md-6",[
						label(".form-label",{attrs: {for:'newPassword'}},["新しいパスワード"]),
            input("#newPassword.form-control", {attrs: {type:"text", placeholder:"半角英数字4桁以上", name:'newPassword'}, props: {value: newPassword}})
					]),
					(prop("newPassword", check))
						? div(".msg.mt-1",["※",prop("newPassword",check)])
						: null
					,
					div(".col-md-6",[
						label(".form-label",{attrs: {for:'checkPassword'}},["確認用パスワード"]),
            input("#checkPassword.form-control", {attrs: {type:"text", placeholder:"新しいパスワードを再入力", name:'checkPassword'}, props: {value: checkPassword}})
					]),
					(prop("checkPassword", check))
						? div(".msg.mt-1",["※",prop("checkPassword",check)])
						: null
					,
					(msg !== null)
						? div(".msg.mt-1",["※",msg])
						: null
						,
					div(".d-grid.gap-4.mt-4.col-md-6",[
            button(`#btnUpdate.btn.btn-primary.${disabled}`, {attrs: {type: "button"}},["パスワードを変更"]),
            button("#btnReturn.btn.btn-success", {attrs: {type: "button"}},["戻る"])
					]),
			])
		})
}
